<template>
  <div>
    <script :id="editorid" type="text/plain"></script>
  </div>
</template>
<script>
  let editorid = 1;
  export default {
    name: 'UE',
    data () {
      return {
        editor: null
      }
    },
    props: {
      defaultMsg: {
        type: String
      },
      config: {
        type: Object
      }
    },
    beforeCreate(){
      editorid ++;
      this.editorid = "cuseditor"+editorid;
    },
    mounted() {
      setTimeout(()=>{
        const _this = this;
        this.editor = UE.getEditor(this.editorid, this.config); // 初始化UE
            
        this.editor.addListener("ready", function () {
          _this.editor.setContent(_this.defaultMsg); // 确保UE加载完成后，放入内容。
          const imgs = _this.editor.body.getElementsByTagName('img');
          Promise.all(Array.prototype.slice.call(imgs).map(item=>{
            return new Promise(function(resolve,reject){
              item.addEventListener('load',function(){
                resolve();
              });
              item.addEventListener("error",function(){
                resolve();
              });
            });
          })).then(()=>{
            if(_this.config.customFrameHeight){
              _this.editor.setHeight(_this.config.customFrameHeight);
            }else{
              _this.editor.enableAutoHeight();
            }
          });
        });
      })
    },
    method(){
    },
    getUEContent() { // 获取内容方法
        return this.editor.getContent()
    },
    destroyed() {
      this.editor.destroy();
    }
  }
</script>